import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initOfflineSync } from "@/lib/offline";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker for PWA / offline support.
//
// We also reload the page exactly once when a new service worker takes
// control, so users receive fresh JS/HTML bundles immediately after a deploy
// instead of running last week's cached shell. Guard with `_reloading` so we
// don't infinite-loop on the initial page load (that also fires
// `controllerchange` if the SW was previously unregistered).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[SW] registration failed:", err));
  });
  let _reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (_reloading) return;
    _reloading = true;
    // Small delay so any in-flight React state has a chance to settle before
    // the reload — avoids the "page flashed and lost my form" UX.
    setTimeout(() => window.location.reload(), 200);
  });
}

// Kick off the background mutation-sync watcher
initOfflineSync();
